const ValidationGap = () => {
    return <>GAP !</>;
};

export default ValidationGap;
